export default __webpack_public_path__ + "static/logo-dddb259f9aa3f4b23eb5688110998b0c.png";